module.exports = __webpack_public_path__ + "static/img/14002003.dc53114c.png";